import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { MaterialModule, MdIconModule, MdInputModule, MdCheckboxModule } from '@angular/material';

import { Paginator } from './paginator.component';
import { DataBoxComponent } from './data-box.component';
import { DatetimePickerModule } from '@neoprospecta/angular-datetimepicker';
import { CustomPipesModule } from '@neoprospecta/angular-custom-pipes';


export class DataBoxModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MdCheckboxModule,
    MdIconModule,
    MdInputModule,
    DatetimePickerModule,
    CustomPipesModule
  ],
  declarations: [
    DataBoxComponent,
    Paginator
  ],
  exports: [
    DataBoxComponent,
    Paginator
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
